/**
 * Extract the org slug from the current hostname.
 *
 * Expected patterns:
 *   {org}.intelliauth.com       → org slug = "org"
 *   {org}.localhost              → org slug = "org" (local dev)
 *
 * Returns null if on the root domain (no subdomain detected).
 */
export function getOrgSlug(): string | null {
  const hostname = window.location.hostname

  // Local development: {org}.localhost
  if (hostname.endsWith('.localhost') || hostname.match(/^[^.]+\.localhost$/)) {
    const parts = hostname.split('.')
    if (parts.length >= 2 && parts[0] !== 'console') {
      return parts[0]
    }
    return null
  }

  // Production: {org}.intelliauth.com
  const parts = hostname.split('.')
  // At least 3 parts: org.intelliauth.com
  if (parts.length >= 3) {
    const sub = parts[0]
    // Skip known non-org subdomains
    if (sub === 'console' || sub === 'www') {
      return null
    }
    return sub
  }

  return null
}

/**
 * Check if the current hostname is the platform console.
 */
export function isConsoleHost(): boolean {
  const hostname = window.location.hostname
  return hostname.startsWith('console.')
}
